import {RoleMin} from "platformed-client/types";
import useTranslate from "platformed-components/i18n/useTranslate";

type TranslateFn = ReturnType<typeof useTranslate>;

// A distinct, hardcoded colour per system role for easy scanning. Account-custom
// roles (no system_role) fall back to gray.
export const ROLE_COLORS: Record<string, string> = {Admin: "purple", VendorToolkit: "blue", TPRM: "green"};

export const roleColor = (role: Pick<RoleMin, "system_role">): string =>
  (role.system_role && ROLE_COLORS[role.system_role]) || "gray";

/** Display name for a role: translated label for system roles, stored name otherwise. */
export const roleLabel = (role: Pick<RoleMin, "system_role" | "name">, t: TranslateFn): string => {
  switch (role.system_role) {
    case "Admin":
      return t("c.Admin");
    case "VendorToolkit":
      return t("c.Vendor_toolkit");
    case "TPRM":
      return t("c.Audit");
    default:
      return role.name;
  }
};
